export default __webpack_public_path__ + "ba8e560.png";